import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";

interface AlertOnSaveConfirmationProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  setAlertModelShow?: any;
  submitHandler?: () => void;
}

const AlertOnSaveConfirmation: React.FC<AlertOnSaveConfirmationProps> = ({
  open,
  title,
  onHide = () => {},
  setAlertModelShow,
  submitHandler = () => {}
}) => {
  const classes = useStyles();

  const closeModel = () => {
    setAlertModelShow(false);
    onHide();
  };

  // const submitHandler = () => {
  //   setAlertModelShow(false);
  //   onHide();
  // };

  return (
    <Popup
      open={open}
      title={title || ""}
      onHide={onHide}
      fullWidth
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
       footer={
              <>
                <CustomButton variant="outlined" title="No" onClick={closeModel} />
                <CustomButton title="Yes" onClick={submitHandler} />
              </>
            }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Sending or saving this quote will mark the job as confirmed.
              Continue?
            </Alert>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertOnSaveConfirmation;
